import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import C from "Constants";
import StripeForm from "components/payment-gateway/stripe/StripeForm";
import CheckoutDotComContainer from "components/payment-gateway/CheckoutDotCom";
import PayByContainer from "components/payment-gateway/payby.container";
import AFSPaymentContainer from "modules/afs";
import { setCurrentPaymentMethod } from "store/app/AppReducer";

export const ErrorMessage = ({ message }) => (
  <div className="mx-4 mb-3 border border-gray-200 rounded-md bg-gray-100  text-center text-danger-200">
    {message}
  </div>
);

function CardWidgets({
  integrationsByName,
  captureCheckoutDotComPayment,
  redirectLink,
  className = "mt-4",
  isNewUI = false,
  setcardProcessing = () => {},
  handleSuceessOrderRoute = () => {},
}) {

  const dispatch = useDispatch();
  const { selectedPaymentType } = useSelector((state) => state.PaymentMethodReducer);

  const activePaymentMethod = useMemo(() => {
    if (integrationsByName[C.AFS_PAYMENT]) return C.AFS_PAYMENT;
    if (integrationsByName[C.STRIPE]) return C.STRIPE;
    if (integrationsByName[C.PAYBY]) return C.PAYBY;
    if (integrationsByName[C.CHECKOUT_DOT_COM]) return C.CHECKOUT_DOT_COM;
    return null;
  }, [integrationsByName]);

  useEffect(() => {
    if (!activePaymentMethod) return;
    localStorage.setItem("activePaymentMethod", activePaymentMethod);
    localStorage.setItem("currentEnvironment", process.env.REACT_APP_ENV);
    dispatch(setCurrentPaymentMethod(activePaymentMethod));
  }, [activePaymentMethod, dispatch]);

  if(!selectedPaymentType || selectedPaymentType !== C.WALLET?.NEW_CARD) {
    return null;
  }

  if (!activePaymentMethod) {
    return (
      <ErrorMessage message="No payment methods are currently available. Please contact support." />
    );
  }

  if (activePaymentMethod === C.AFS_PAYMENT) {
    return (
      <div className={className}>
        <AFSPaymentContainer />
      </div>
    );
  }

  if (activePaymentMethod === C.STRIPE) {
    return (
      <div className={className}>
        <StripeForm isNewUI={isNewUI} />
      </div>
    );
  }

  if (activePaymentMethod === C.PAYBY) {
    return (
      <PayByContainer
        isNewUI={isNewUI}
        integrationsByName={integrationsByName}
        redirectLink={redirectLink}
        captureCheckoutDotComPayment={captureCheckoutDotComPayment}
        setcardProcessing={setcardProcessing}
        handleSuceessOrderRoute={handleSuceessOrderRoute}
      />
    );
  }

  if (activePaymentMethod === C.CHECKOUT_DOT_COM) {
    return (
      <div className={className}>
        <CheckoutDotComContainer
          capturePayment={(token) =>
            captureCheckoutDotComPayment(token, redirectLink)
          }
          redirectLink={redirectLink}
        />
      </div>
    );
  }

  return null;
}

export default CardWidgets;
